<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="cancelEvent.emit()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        {{ "control_testimonial_button_settings" | translate }}
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body">
    <div class="form form-horizontal">
        <div class="form-group mb-20">
            <label class="col-xs-12">
                {{ "control_text" | translate }}
            </label>
            <div class="col-xs-12">
                <input class="form-control" [formControl]="label" />
            </div>
        </div>

        <div class="form-row mb-20">
            <div class="form-group">
                <label class="col-xs-12">
                    {{ "control_style" | translate }}
                </label>
                <div class="col-xs-6">
                    <select class="form-control" [formControl]="styleType">
                        <option [ngValue]="EButtonStyleType.primary">
                            {{ "control_appearance_primary" | translate }}
                        </option>
                        <option [ngValue]="EButtonStyleType.secondary">
                            {{ "control_appearance_secondary" | translate }}
                        </option>
                        <option [ngValue]="EButtonStyleType.custom">
                            {{ "control_appearance_custom" | translate }}
                        </option>
                    </select>
                </div>
                <div class="col-xs-6">
                    <div class="btn-group d-flex">
                        <sp-radio-group
                            [selected]="size.value"
                            [type]="ERadioGroupType.size"
                            (changeSelectedEvent)="setSize($event)"
                        ></sp-radio-group>
                    </div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="styleType.value === EButtonStyleType.custom">
            <div class="form-row">
                <web-custom-button
                    [parentBase]="buttonBase.value"
                    [parentHover]="buttonHover.value"
                    (valueChangeEvent)="customButtonChangeHandler($event)"
                ></web-custom-button>
            </div>
        </ng-container>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
